import InfoBlock from "../../components/MarketingComponents/infoBlock";

import logoIcon from "../../assets/images/cloud.png";
import lockIcon from "../../assets/images/lockLight.png";
import lightbulbIcon from "../../assets/images/creative.png";

export default function MarketingSection() {
  const whatIsFileFreakText = `FileFreak.io is a next-generation cloud storage platform designed for both individuals and developers. 
  We provide a fast, secure, and reliable way to store, access, and share files. Whether you're working solo, running a business, 
  or building data-heavy applications, FileFreak.io adapts to your needs. With enterprise-grade security, scalable infrastructure, 
  and a sleek interface, it’s the smarter way to manage your digital content. Developer tools and APIs are on the way to make 
  integration seamless for your apps and services.`;

  const securityText = `Your data is protected with industry-leading encryption both at rest and in transit. 
  FileFreak.io uses multiple layers of security, including access control, detailed audit logs, and optional two-factor authentication 
  to safeguard your files. We are committed to privacy and never sell or share your data. Security is built into every layer of our platform, 
  from uploads to file sharing. You stay in control of your content at all times.`;

  const whyUseText = [
    "Why pay for storage you don’t use? Most Dropbox users are forced into high-cost plans for large storage tiers they may never fill. FileFreak.io is different—we offer affordable, flexible pricing based on your actual usage, making it the smart choice for individuals and teams who want to scale cost-effectively.",

    "Built with developers in mind. Coming soon: developer-focused APIs and SDKs designed for modern workflows. Whether you're building a SaaS platform, mobile app, or internal tool, FileFreak.io gives you ready-to-integrate file storage solutions, so you can spend less time managing infrastructure and more time building features.",

    "A clean, user-friendly interface. Our sleek UI makes navigation effortless—no clutter, no learning curve. Upload, manage, and share files without friction.",

    "Fast upload & download speeds. Backed by a globally distributed infrastructure and optimized caching, FileFreak.io offers blazing-fast transfers—whether you're uploading large datasets or streaming media.",

    "Built for the future of cloud storage. FileFreak.io is not just a Dropbox alternative. It’s a next-gen platform designed for scalability, developer flexibility, and user control. With features like secure public sharing, object-level privacy controls, file versioning, and upcoming role-based access support, we're solving the problems legacy platforms never addressed.",
  ];

  const instagramUrl = "https://www.instagram.com/filefreak.io?igsh=MTVlNmIxZjlzZTRhdQ%3D%3D&utm_source=qr";

  return (
    <section id="info">
      {/* FAQ */}
      <h2 className="faq-header">Frequently Asked Questions</h2>
      <div className="info-1">
        <InfoBlock header="What is FileFreak.io?" textContent={whatIsFileFreakText} image={logoIcon} />
        <InfoBlock header="How Secure is It?" textContent={securityText} image={lockIcon} />
        <InfoBlock header="Why Use FileFreak vs Dropbox?" textContent={whyUseText} image={lightbulbIcon} />
      </div>

      {/* <InfoBlock
          header="When is the Official Launch?"
          textContent={launchText}
          image={calendarIcon}
          CTA={
            <button
              className="standard-button btn-hover-transparent"
              style={{ width: "fit-content", whiteSpace: "nowrap" }}
              onClick={() => window.open(instagramUrl, "__blank")}
            >
              Follow Us on Instagram For Updates
            </button>
          }
        /> */}
    </section>
  );
}
